import { stats } from "@/mocks/communityData";

export default function Hero() {
  return (
    <section id="top" aria-label="吃瓜聚集 品牌介绍" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20a%20lively%20online%20discussion%20community%2C%20many%20diverse%20colorful%20speech%20bubbles%20and%20chat%20bubbles%20floating%20in%20the%20air%2C%20megaphone%20and%20lightning%20sparks%2C%20warm%20cream%20ivory%20background%2C%20coral%20red%20and%20fresh%20leaf%20green%20and%20amber%20gold%20accent%20colors%2C%20subtle%20confetti%20and%20rounded%20shapes%2C%20playful%20modern%20editorial%20art%2C%20soft%20gradients%2C%20high%20contrast%20clean%20balanced%20composition&width=1600&height=900&seq=gua-hero-2026&orientation=landscape"
          alt="吃瓜聚集在线讨论社区插画背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/45 to-background-50"></div>
      </div>

      <div className="container-x flex min-h-[640px] flex-col items-center justify-center pb-24 pt-32 text-center md:min-h-[720px]">
        <span className="animate-rise chip mb-6 bg-accent-100 text-accent-900">
          <i className="ri-flashlight-fill text-sm"></i>
          全网瓜友，在线聚集
        </span>

        <h1
          className="animate-rise text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-6xl"
          style={{ animationDelay: "0.08s" }}
        >
          吃瓜聚集<span className="text-primary-500">⚡</span>
          <span className="mx-3 hidden text-foreground-400 sm:inline">/</span>
          <span className="mt-2 block bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent md:mt-0 md:inline">
            每一件大事，都有你的声音
          </span>
        </h1>

        <p
          className="animate-rise mt-6 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg"
          style={{ animationDelay: "0.18s" }}
        >
          评论区、话题广场、讨论版块汇聚一堂。热门事件一起围观，
          最新爆料带你看懂来龙去脉，随手一帖也能引爆全网讨论。
          别再独自吃瓜，来讨论区加入这场全民互动。
        </p>

        <div
          className="animate-rise mt-9 flex flex-col gap-3 sm:flex-row sm:items-center"
          style={{ animationDelay: "0.28s" }}
        >
          <a href="#plaza" className="btn-primary px-7 py-3 text-base">
            <i className="ri-chat-smile-3-line mr-2 text-lg"></i>
            去话题广场开聊
          </a>
          <a href="#trending" className="btn-ghost px-7 py-3 text-base">
            先围观今日热榜
            <i className="ri-arrow-down-line ml-2"></i>
          </a>
        </div>

        {/* floating stickers */}
        <div className="pointer-events-none absolute left-[6%] top-[30%] hidden animate-floaty items-center gap-2 rounded-2xl bg-background-50/90 px-4 py-3 ring-1 ring-background-200 lg:flex">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700"><i className="ri-thumb-up-fill"></i></span>
          <span className="text-sm font-semibold text-foreground-800">今日热帖 4.6万赞</span>
        </div>
        <div className="pointer-events-none absolute right-[7%] top-[26%] hidden animate-floaty items-center gap-2 rounded-2xl bg-background-50/90 px-4 py-3 ring-1 ring-background-200 lg:flex" style={{ animationDelay: "1.2s" }}>
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-100 text-accent-800"><i className="ri-fire-fill"></i></span>
          <span className="text-sm font-semibold text-foreground-800">爆款话题热度 982万</span>
        </div>
      </div>

      {/* Stats bar */}
      <div className="relative z-10 container-x -mt-10 pb-20">
        <dl className="card grid grid-cols-2 gap-y-6 px-6 py-7 md:grid-cols-4 md:px-8">
          {stats.map((s) => (
            <div key={s.label} className="flex items-center gap-4 justify-center">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                <i className={s.icon + " text-xl"}></i>
              </span>
              <div>
                <dd className="font-heading text-xl font-black text-foreground-950 md:text-2xl">{s.value}</dd>
                <dt className="text-xs text-foreground-500 md:text-sm">{s.label}</dt>
              </div>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}